module.exports = __webpack_public_path__ + "double-hibana-desktop.jpg";